import {
  DATA_CONNECTOR_XANO_DATA_BASE_TABLE_BEGIN,
  DATA_CONNECTOR_XANO_DATA_BASE_TABLE_SUCCESS,
  DATA_CONNECTOR_XANO_DATA_BASE_TABLE_FAILURE,
  DATA_CONNECTOR_XANO_DATA_BASE_TABLE_DISMISS_ERROR,
} from './constants';
import axios from 'axios'
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { toast } from 'react-toastify';


export function xanoDataBaseTable(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_XANO_DATA_BASE_TABLE_BEGIN,
    });
    const { projectId, version } = args
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/xano/database`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_XANO_DATA_BASE_TABLE_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },

        (err) => {
          dispatch({
            type: DATA_CONNECTOR_XANO_DATA_BASE_TABLE_FAILURE,
            data: { error: err },
          });
          toast.error('invalid access token !');
          console.log('api calling error>>>>>', err);
          reject(err);
        },
      );
    });
    return promise;
  };
}


export function dismissXanoDataBaseTableError() {
  return {
    type: DATA_CONNECTOR_XANO_DATA_BASE_TABLE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_XANO_DATA_BASE_TABLE_BEGIN:
      return {
        ...state,
        xanoDataBaseTablePending: true,
        xanoDataBaseTableError: null,
      };

    case DATA_CONNECTOR_XANO_DATA_BASE_TABLE_SUCCESS:
      return {
        ...state,
        xanoDataBaseTablePending: false,
        xanoDataBaseTableError: null,
        xanoDataBaseTable: action.data
      };

    case DATA_CONNECTOR_XANO_DATA_BASE_TABLE_FAILURE:
      return {
        ...state,
        xanoDataBaseTablePending: false,
        xanoDataBaseTableError: action.data.error,
      };

    case DATA_CONNECTOR_XANO_DATA_BASE_TABLE_DISMISS_ERROR:
      return {
        ...state,
        xanoDataBaseTableError: null,
      };

    default:
      return state;
  }
}
